<template>
    <ul :class="[passiveMenuClass,parentActive ? activeMenuClass : '']">
      <li v-for="subitem in submenuItems" :key="subitem.id" >
          <a v-bind:href="subitem.url"
             :class="[subitem.active? activeLinkClass : '']">
            <span :style="this.$store.getters.positionLeft">{{ subitem.name }}</span>
          </a>
      </li>
    </ul>
</template>

<script>
export default {
  name: 'ResponsiveSubMenu',
  props: {
    parentActive:false,
    submenuItems:Array
  },
  data() {
    return {
      activeMenuClass: 'expand',
    }
  },
}
</script>
